// removed by extract-text-webpack-plugin
module.exports = {"base":"Warning_base--2BIGy","base__message":"Warning_base__message--36548","baseMessage":"Warning_base__message--36548","base__warning":"Warning_base__warning--2ZEoG","baseWarning":"Warning_base__warning--2ZEoG","base__alert":"Warning_base__alert--QgS8c","baseAlert":"Warning_base__alert--QgS8c"};


//////////////////
// WEBPACK FOOTER
// ./components/Warning/Warning.scss
// module id = 382
// module chunks = 11 12